module.exports = __webpack_public_path__ + "static/media/libro9.5f6b5366.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro9.png
// module id = 357
// module chunks = 0